import React, { PureComponent } from 'react'
import { Spin, Button, Form, Row, Col, Input, InputNumber, message, Radio, Modal, Table, Upload, Icon } from 'antd'
import { versionsDetail, versionsList, editVersions } from '_src/api/api'
import './style.less'
import { uploaddir } from '../../api/request'
import FileUpload from '../../utils/fileUpload'

const { TextArea } = Input

@Form.create({ name: '' })
class Versions extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: true,
      params: {
        pageNum: 0,
        pageSize: 10,
      },
      pageData: {
        total: 0,
        current: 1,
      },
      list: [],
      fileList: [],
      columns: [
        {
          title: '当前版本',
          align: 'center',
          dataIndex: 'code',
        },
        {
          title: '系统',
          align: 'center',
          dataIndex: 'type',
          render: item => item === 20 ? 'Android' : 'iOS'
        },
        {
          title: '最小使用版本',
          align: 'center',
          dataIndex: 'minCode',
        },
        {
          title: '更新内容',
          align: 'center',
          dataIndex: 'remark',
        },
        {
          title: '发布日期',
          align: 'center',
          dataIndex: 'createAt',
        },
        {
          title: '安装包',
          align: 'center',
          render: item => item.type === 20 ? <a href={item.link} rel="noopener noreferrer"><Button icon="download">下载</Button></a> : '无'
        },
        {
          title: '操作',
          align: 'center',
          render: item => <Button icon="edit" type='primary' style={{ marginRight: 20 }} onClick={() => this.edit(item.id)}>编辑</Button>,
        },
      ]
    }
  }
  componentDidMount () {
    const { params } = this.state
    this.loadList(params)
  }

  loadList (params) {
    this.setState({ isLoading: true })
    versionsList(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 系统切换
  typeChange = (e) => {
    const value = e.target.value
    const { params } = this.state
    params.pageNum = 0
    if (value) {
      params.type = value
    } else {
      delete params.type
    }
    this.setState({params})
    this.loadList(params)
  }

  // 编辑
  edit = (id) => {
    versionsDetail({id})
      .then(res => {
        this.setState({
          info: res.data,
          visible: true,
          type: res.data.type,
        })
      })
  }

  // 发布推送
  create = () => this.setState({ visible: true })

  // 编辑-系统类型切换
  editTypeChange = (e) => {
    this.setState({type: e.target.value})
  }

  // 上传文件
  handleChange = ({ fileList }) => {
    this.setState({ fileList, upload: true })
  }

  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const {upload, info, fileList} = this.state
        const id = info ? info.id : ''
        const addPrms = new Promise((resolve, reject) => {
          if (values.type === 20) {
            if (upload) {
              let forms = new FormData()
              forms.append('file', values.link.file)
              const hide = message.loading('上传APK', 0)
              let name = values.link.file.name
              let reader = new window.FileReader();
              let rs = reader.readAsArrayBuffer(values.link.file);
              let blob = null;
              reader.onload = (e) => {
                  if (typeof e.target.result === 'object') {
                      blob = new Blob([e.target.result])
                  } else {
                      blob = e.target.result
                  }
                  FileUpload(uploaddir, {blob,name}).then( res => {
                    hide()
                    values.link = res
                    resolve(values)
                  }).catch(err => {
                      hide()
                      message.error(err.response ? err.response.data : '文件上传失败')
                      return reject(err)
                  })
              }
            } else if (info) {
              values.link = info.link
              resolve(values)
            } else {
              message.error('请上传APK')
              reject(err)
            }
          } else {
            resolve(values)
          }
        })
        addPrms
          .then(values => {
            const hide = message.loading('提交数据中', 0)
            editVersions(values, id)
              .then(res => {
                const { params } = this.state
                let p = params
                p.pageNum = 0
                this.setState({ 
                  visible: false,
                  upload: false,
                  info: '',
                })
                hide()
                message.success('提交成功！', 1.2, () => {
                  this.loadList(p)
                })
              })
          })
          .catch(err => {
            console.log(err)
          })
      }
    })
  }

  render () {
    const { info, fileList, isLoading, columns, list, pageData, visible, type } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div className="push-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <Row style={{ paddingBottom: 20 }}>
          <Col lg={{ span: 8 }} style={{ width: 180, marginBottom: 20 }} className="flex-h-a">
            <Button className='creat-station' type="primary" icon="plus" style={{ width: 130 }} onClick={this.create}>发布版本</Button>
          </Col>
          <Col lg={{ span: 8 }} style={{width: 420}} className="flex-h-a">
            <Radio.Group defaultValue="" buttonStyle="outline" onChange={this.typeChange}>
              <Radio.Button value=''>全部版本</Radio.Button>
              <Radio.Button value={20}>Android 版本</Radio.Button>
              <Radio.Button value={10}>iOS 版本</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
        <Modal
          title={info ? '编辑版本' : '发布版本'}
          visible={visible}
          onCancel={() => this.setState({ 
            visible: false, 
            upload: false, 
            info: '',
          })}
          width={600}
          footer={false}
          destroyOnClose
        >
          <Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
            <Form.Item label="App版本号：" className='flex'>
              {getFieldDecorator('code', {
                rules: [{
                  required: true,
                  message: '请输入App版本号',
                }],
                initialValue: info ? info.code : '',
              })(
                <InputNumber placeholder="App版本号" style={{ width: 300 }} />
              )}
            </Form.Item>
            <Form.Item label="最低版本号：" className='flex'>
              {getFieldDecorator('minCode', {
                rules: [{
                  required: true,
                  message: '请输入最低使用版本号',
                }],
                initialValue: info ? info.minCode : '',
              })(
                <InputNumber placeholder="最低使用版本号" style={{ width: 150 }} />
              )}
              （小于最低版本需要强制更新）
            </Form.Item>
            <Form.Item label="更新内容：" className='flex'>
              {getFieldDecorator('remark', {
                rules: [{
                  required: true,
                  message: '请输入更新内容',
                }],
                initialValue: info ? info.remark : '',
              })(
                <TextArea placeholder="更新内容" style={{ width: 300, height: 70 }} autosize={false} />
              )}
            </Form.Item>
            <Form.Item label="系统类型：" className='flex'>
              {getFieldDecorator('type', {
                rules: [{
                  required: true,
                  message: '请选择系统类型',
                }],
                initialValue: info ? info.type : '',
              })(
                <Radio.Group onChange={this.editTypeChange}>
                  <Radio value={20}>Android 系统</Radio>
                  <Radio value={10}>iOS 系统</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
            {
              type === 20 && (
                <Form.Item label="安装包" className='flex'>
                  {getFieldDecorator('link', {
                    rules: [{
                      required: true,
                      message: '请上传安装APK',
                    }],
                    initialValue: info ? info.link : '',
                  })(
                    <Upload
                      fileList={fileList}
                      onChange={this.handleChange}
                      beforeUpload = {()=>{ return false }}
                    >
                      {fileList.length >= 1 ? null : <Button><Icon type="upload" /> 上传安装包</Button>}
                    </Upload>
                  )}
                </Form.Item>
              )
            }
            <Form.Item>
              <Button type="primary" htmlType="submit" size='large' style={{ width: 300, marginLeft: 100, marginTop: 0 }}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default Versions